import { Card, Flex, Typography } from "antd";
import { Drag } from "components/icons";
import {
  FileFilled,
  FilePdfFilled,
  FilePptFilled,
  FileWordFilled,
  Html5Filled,
} from "@ant-design/icons";
import { useAntTheme } from "hooks/useAntTheme/";
import { SortableSection } from "./SortableSection";
import { useMemo } from "react";
import { getFileExtensionFromFileName } from "helpers/uploader/";

export const SortableFilePreview = ({
  width,
  fileName,
  format = "",
}: {
  width: number;
  fileName: string;
  format?: string;
}) => {
  const { theme } = useAntTheme();

  const formatIcon = useMemo(() => {
    const fileExtension = getFileExtensionFromFileName(fileName);
    const cleanFormat = format.replaceAll("application/", "").toLowerCase();
    const iconStyle = {
      fontSize: width / 3,
      color: theme.colorTextDescription,
    };

    const iconMap = {
      pdf: FilePdfFilled,
      doc: FileWordFilled,
      docx: FileWordFilled,
      ppt: FilePptFilled,
      pptx: FilePptFilled,
      html: Html5Filled,
      htm: Html5Filled,
    };

    const IconComponent = iconMap[fileExtension || cleanFormat] || FileFilled;

    return <IconComponent style={iconStyle} />;
  }, [format, fileName, width, theme.colorTextDescription]);

  return (
    <SortableSection id={fileName} key={fileName}>
      <Card
        styles={{ body: { padding: 10, paddingTop: 20 } }}
        style={{ width }}
      >
        <Flex vertical align="center" justify="center" gap={16}>
          <Flex
            style={{
              position: "absolute",
              top: 5,
              right: 10,
              opacity: 0.5,
            }}
          >
            <Drag fill={theme.colorTextDescription} />
          </Flex>
          {formatIcon}
          <Typography.Paragraph
            ellipsis={{ tooltip: true, rows: 1 }}
            style={{ textAlign: "center", width: "100%" }}
          >
            {fileName}
          </Typography.Paragraph>
        </Flex>
      </Card>
    </SortableSection>
  );
};
